export function useSupportedLangCodes() {
  const config = useRuntimeConfig()
  const codes: string[] = config.public.i18n.locales.map(
    (el) => {
      const locale = el as { code: string }

      return locale.code
    },
  )

  const validate = (lang: string) => {
    return codes.includes(lang)
  }

  return { codes, validate }
}
